import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_MEMBER_DOCUMENTS_REQUEST: '',
  GET_MEMBER_DOCUMENTS_SUCCESS: '',
  GET_MEMBER_DOCUMENTS_FAILURE: '',

  GET_DOCUMENT_CATEGORY_REQUEST: '',
  GET_DOCUMENT_CATEGORY_SUCCESS: '',
  GET_DOCUMENT_CATEGORY_FAILURE: '',

  GET_CATEGORY_DOCS_FOR_MEMBER_REQUEST: '',
  GET_CATEGORY_DOCS_FOR_MEMBER_SUCCESS: '',
  GET_CATEGORY_DOCS_FOR_MEMBER_FAILURE: '',

  GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_REQUEST: '',
  GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_SUCCESS: '',
  GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_FAILURE: '',

  GET_DOCUMENT_GROUPS_AND_CATEGORIES_REQUEST: '',
  GET_DOCUMENT_GROUPS_AND_CATEGORIES_SUCCESS: '',
  GET_DOCUMENT_GROUPS_AND_CATEGORIES_FAILURE: '',

  UPDATE_DOCUMENT_CATEGORY_REQUEST: '',
  UPDATE_DOCUMENT_CATEGORY_SUCCESS: '',
  UPDATE_DOCUMENT_CATEGORY_FAILURE: '',

  DELETE_MEMBER_DOCUMENT_REQUEST: '',
  DELETE_MEMBER_DOCUMENT_SUCCESS: '',
  DELETE_MEMBER_DOCUMENT_FAILURE: '',

  DOWNLOAD_MEMBER_DOCUMENT_REQUEST: '',
  DOWNLOAD_MEMBER_DOCUMENT_SUCCESS: '',
  DOWNLOAD_MEMBER_DOCUMENT_FAILURE: '',

  POST_LATEST_DOCUMENTS_REQUEST: '',
  POST_LATEST_DOCUMENTS_SUCCESS: '',
  POST_LATEST_DOCUMENTS_FAILURE: '',

  GET_SPECS_DOCUMENT_REQUEST: '',
  GET_SPECS_DOCUMENT_SUCCESS: '',
  GET_SPECS_DOCUMENT_FAILURE: '',

  GET_PROVIDERS_DOCUMENT_REQUEST: '',
  GET_PROVIDERS_DOCUMENT_SUCCESS: '',
  GET_PROVIDERS_DOCUMENT_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityDocuments');

export default types;
